// extracted by mini-css-extract-plugin
module.exports = {"school_select_box":"Units_school_select_box_GcLXp","add_group":"Units_add_group_2NpV4","assistance":"Units_assistance_1KSai","bulk_edit":"Units_bulk_edit_OHQ4Z"};